import styled from "styled-components/macro"
import { GiftListHeader } from "../styles/giftList"

export const HelpButton = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: #fff3;
  border-radius: 50px;
  cursor: pointer;
  padding-right: 4px;
  line-height: 20px;
  height: 24px;
`

export const HelpDiv = styled.div`
  width: 100%;
  color: #6d6d6d;
  border-bottom: 1px solid #ddd;
`

export const HelpHeader = styled(GiftListHeader)`
  margin: 0;
  color: #4d4d4d;
  font-size: ${props => props.theme.fontSize.header};
  font-weight: bold;
  padding: 8px 0;
  min-height: 56px;

  & img {
    margin: 0 8px;
  }
`

export const HelpAnswer = styled.p`
  margin: ${props => props.collapsed ? "4px 0 12px" : "0"};
  font-size: ${props => props.theme.fontSize.text};
  white-space: pre-line;
  transition: all .3s ease-in-out;
  max-height: ${props => props.collapsed ? "800px" : "0"};
  text-overflow: clip;
  overflow: hidden;
`

export const Expand = styled.span`
  padding: 0 5px;
  cursor: pointer;
  color: ${props => props.theme.colors.orange};
`
